import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { useAdmin } from './AdminContext';
import { useAdminPage } from './useAdminPage';
import GumballIcon from '../components/GumballIcon';
import './css/admin-login.css';

export default function AdminLogin() {
  useAdminPage();
  const { user, login, loading } = useAdmin();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  if (loading) {
    return (
      <div className="admin-loading">
        <div className="admin-spinner" />
      </div>
    );
  }

  if (user) return <Navigate to="/admin" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      await login(username, password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Login failed');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-card">
        <div className="admin-login-header">
          <span className="admin-login-icon"><GumballIcon name="bubble" size={48} /></span>
          <h1>Gumball Buddies Admin</h1>
          <p>Sign in to manage site content</p>
        </div>

        <form onSubmit={handleSubmit} className="admin-form">
          {error && <div className="admin-alert admin-alert-error">{error}</div>}

          <label className="admin-label">
            Username
            <input
              className="admin-input"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              required
            />
          </label>

          <label className="admin-label">
            Password
            <div className="admin-password-wrap">
              <input
                className="admin-input admin-input-password"
                type={showPassword ? 'text' : 'password'}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoComplete="current-password"
                required
              />
              <button
                type="button"
                className="admin-password-toggle"
                onClick={() => setShowPassword((v) => !v)}
                aria-label={showPassword ? 'Hide password' : 'Show password'}
                aria-pressed={showPassword}
              >
                {showPassword ? (
                  <svg viewBox="0 0 24 24" aria-hidden="true" className="admin-password-icon">
                    <path d="M3.3 3.3 20.7 20.7M10.7 10.7a2.5 2.5 0 0 0 3.5 3.5M6.7 6.8C4.6 8.4 3.2 10.4 2 12c1.8 3 5 5 10 5 1.8 0 3.4-.4 4.8-1.1M9.5 5.1C10.3 5 11.1 5 12 5c5 0 8.2 2 10 5-.8 1.3-1.9 2.5-3.2 3.4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                  </svg>
                ) : (
                  <svg viewBox="0 0 24 24" aria-hidden="true" className="admin-password-icon">
                    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z" fill="none" stroke="currentColor" strokeWidth="2" />
                    <circle cx="12" cy="12" r="3" fill="none" stroke="currentColor" strokeWidth="2" />
                  </svg>
                )}
              </button>
            </div>
          </label>

          <button type="submit" className="admin-btn admin-btn-primary" disabled={submitting}>
            {submitting ? 'Signing in...' : 'Sign In'}
          </button>
        </form>

        {process.env.NODE_ENV === 'development' && (
          <p className="admin-login-hint">
            Local dev: set <code>ADMIN_USERNAME</code> and <code>ADMIN_PASSWORD</code> in your root <code>.env</code>.
          </p>
        )}
      </div>
    </div>
  );
}
